const isShopInPathname = (pathname: string): boolean => {
  const pathSegments = pathname?.split('/').filter(Boolean);
  return pathSegments?.some(segment => segment.toLowerCase() === 'shop');
};

export default isShopInPathname;
